
<tps-assistant-message [sender]="i18n.translate('assistant:tebisAssistant')()" [sentDate]="data().sentDate" [messageContent]="i18n.translate('assistant:taskCreatedMessage')()" role="assistant">
  <tps-windowed-router-link [url]="['/tasks', data().taskID].join('/')" [tabLabel]="getTaskTabLabel(data().taskID)">
    <ngt-link href="#" matIcon="note_alt">{{ data().taskID }}</ngt-link>
  </tps-windowed-router-link>
</tps-assistant-message>
